import React from 'react';
import { ExternalLink } from 'lucide-react';
import InlineTooltip from '../Tooltip/InlineTooltip';

const LinkTextArea = ({ value, id, label, handleChange, error, helpText, mandatory }) => {
    return (
        <div className='mb-4' dzt-field-id={id}>
            {label && (
                <label
                    htmlFor={id}
                    className="block text-xs font-semibold uppercase tracking-wider text-stride-muted mb-1.5 flex items-center justify-between"
                >
                    <span className="flex items-center gap-1.5">
                        {label} {mandatory && <span className="text-stride-danger">*</span>}
                        {helpText && (
                            <InlineTooltip
                                content={helpText}
                                imgClass="pt-0.5"
                            />
                        )}
                    </span>
                    {value && (
                        <a 
                            href={value} 
                            target='_blank' 
                            rel="noreferrer"
                            className="text-xs font-medium text-stride-primary hover:text-stride-primary-hover flex items-center gap-1 transition-colors"
                        >
                            <span>Open URL</span>
                            <ExternalLink size={12} />
                        </a>
                    )}
                </label>
            )}
            <div className="relative">
                <textarea
                    id={id}
                    name={id} 
                    rows={2}
                    className="w-full px-3.5 py-2.5 text-sm font-medium text-stride-heading bg-white rounded-lg border border-stride-border focus:border-stride-primary focus:ring-1 focus:ring-stride-primary focus:outline-none transition-all placeholder:text-stride-muted resize-none font-mono text-xs" 
                    placeholder="https://..." 
                    value={value} 
                    onChange={handleChange}
                />
            </div>
            {error && <p className="mt-1.5 text-xs text-stride-danger font-medium">{error}</p>}
        </div>
    );
};

export default LinkTextArea;
